module.exports = __webpack_public_path__ + "static/media/workspace-preview.1be6c9b0.svg";